import { render, staticRenderFns } from "./HostedWaitingListFormSuccess.vue?vue&type=template&id=5cb0c5d7&scoped=true&"
import script from "./HostedWaitingListFormSuccess.vue?vue&type=script&lang=js&"
export * from "./HostedWaitingListFormSuccess.vue?vue&type=script&lang=js&"
import style0 from "./HostedWaitingListFormSuccess.vue?vue&type=style&index=0&id=5cb0c5d7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb0c5d7",
  null
  
)

export default component.exports